<script lang="ts">
	import { format } from 'svelte-i18n';
	import TickedElementPreview from './TickedElementPreview.svelte';

	export let run_on_save = true,
		allowed_for_3rd_party = false,
		scene_enable_val = true;

	console.log('Unused prop "allowed_for_3rd_party" with value: ', allowed_for_3rd_party);

	let assitant_title = $format('allowed_for_voice_assistants', {
		default: 'Allowed for Voice Assistants',
	});
	let run_scene_title = $format('run_on_save', {
		default: 'Run scene on save',
	});
	let scene_enable_title = $format('scene_enebled_msg', {
		default: 'Enabled scene',
	});
</script>

<TickedElementPreview
	icon="fa-solid fa-power-off"
	text={scene_enable_title}
	disabled={!scene_enable_val}
/>
<!-- <TickedElementPreview text={assitant_title} disabled={!allowed_for_3rd_party} /> -->
<TickedElementPreview icon="fa-solid fa-play" text={run_scene_title} disabled={!run_on_save} />
